import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  collegeSize_LIST_START: "collegeSize_LIST_START",
  collegeSize_LIST_SUCCESS: "collegeSize_LIST_SUCCESS",
  collegeSize_LIST_FAILED: "collegeSize_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const collegeSizeListStart = (data) => ({
  type: actionType.collegeSize_LIST_START,
  payload: data,
});

export const collegeSizeListSuccess = (data) => ({
  type: actionType.collegeSize_LIST_SUCCESS,
  payload: data,
});

export const collegeSizeListFailed = (data) => ({
  type: actionType.collegeSize_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function collegeSizeListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.collegeSize_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.collegeSize_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.collegeSize_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* collegeSizeListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      const allcollegeSize = response.data.data.allCollegesizes?.Collegesizes
        ? response.data.data.allCollegesizes.Collegesizes
        : null;
      let finalData = [];
      yield put(collegeSizeListSuccess(allcollegeSize));
    } else {
      messagePopup("", "COLLEGE List failed", "error");
      yield put(collegeSizeListFailed("collegeSize List failed"));
    }
  } catch (error) {
    messagePopup("", "collegeSize List failed", "error");
    yield put(collegeSizeListFailed("collegeSize List failed"));
  }
}

export function* watchcollegeSizeListSaga() {
  yield takeEvery(actionType.collegeSize_LIST_START, collegeSizeListSaga);
}
